import React from 'react';

import PropTypes from 'prop-types';

import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';

import ProductCardImageFromImageService from './ProductCardImageFromImageService';
import ProductCardImageFromImageSet from './ProductCardImageFromImageSet';
import ProductCardImageFromSku from './ProductCardImageFromSku';

const ProductCardImage = ({
  imageServiceUrl,
  swatchLabel,
  images,
  sku,
  permalink,
  isPrimaryProduct = false,
  showPlusSizeImage = false,
}) => {
  const { enabled: shouldUseImageService } = useHasFeature(
    featureNames.SHOULD_USE_IMAGE_SERVICE_URL
  );

  // Image service url is only available for primary products
  // We construct the image service url from the itemNumber from related products at the ProductCard.js level
  // TODO: update fedgraph to pull data from the image service for related products
  if (shouldUseImageService) {
    return (
      <ProductCardImageFromImageService
        imageServiceUrl={imageServiceUrl}
        swatchLabel={swatchLabel}
        showPlusSizeImage={showPlusSizeImage}
      />
    );
  }

  // Primary product cards does not have an image set since it's using data from Cio
  // We have to construct the image url from the sku
  if (isPrimaryProduct) {
    return (
      <ProductCardImageFromSku
        sku={sku}
        permalink={permalink}
        swatchLabel={swatchLabel}
        showPlusSizeImage={showPlusSizeImage}
      />
    );
  }

  // Related product cards have an image set because it comes from the fedgraph api
  return (
    <ProductCardImageFromImageSet
      images={images}
      swatchLabel={swatchLabel}
      showPlusSizeImage={showPlusSizeImage}
    />
  );
};

ProductCardImage.propTypes = {
  imageServiceUrl: PropTypes.string,
  images: PropTypes.object,
  isPrimaryProduct: PropTypes.bool,
  permalink: PropTypes.string,
  showPlusSizeImage: PropTypes.bool,
  sku: PropTypes.string,
  swatchLabel: PropTypes.string,
};

export default ProductCardImage;
